import { Confirmation, RouterContext } from '../../libs/gs-component-right-rail';
import React, { useContext, useState } from 'react';

import { useDeactivateWebsiteMutation } from '../../generated/graphql';
import styles from './Deactivate.scss';
import { TrackingContext } from '../../TrackingContext';
import CVAlert from '../CVAlert';
import Honeybadger from 'honeybadger-js';

interface Props {
  onClose: () => void;
}

export const Deactivate: React.FC<Props> = ({ onClose }) => {
  const { goBack } = useContext(RouterContext);
  const [disableWebsite] = useDeactivateWebsiteMutation();
  const { track } = useContext(TrackingContext);
  const [erroring, setErroring] = useState(false);

  const info = (
    <span className={styles.Deactivate__InfoContainer}>
      <span className={styles.Deactivate__InfoContainer__text}>If you do, keep in mind:</span>
      <ul className={styles.Deactivate__InfoContainer__list}>
        <li>All pages and content will be removed from public view.</li>
        <li>Only your website will be affected — the rest of your account will remain active.</li>
        <li>Removing your website from search engines may take up to 30 days.</li>
        <li>Your website can be reactivated anytime if you change your mind.</li>
      </ul>
    </span>
  );

  const eventName = 'Wedding Website Deletion Interaction';
  const onPrimary = async (): Promise<void> => {
    try {
      await disableWebsite();
      track(eventName, {
        action: 'delete confirmed',
      });

      onClose();
    } catch (error) {
      Honeybadger.notify(error, {
        message: 'Error deactivating website',
        context: {
          error,
        },
      });
      setErroring(true);
    }
  };

  const onSecondary = (): void => {
    track(eventName, {
      action: 'delete cancelled',
    });

    goBack();
  };

  return (
    <>
      <CVAlert erroring={erroring} onTimeout={() => setErroring(false)} />
      <Confirmation
        onPrimaryAction={onPrimary}
        primaryText="Deactivate website"
        secondaryText="Cancel"
        onSecondaryAction={onSecondary}
        question="Deactivate your website?"
        info={info}
      />
    </>
  );
};
